import { calmTokens as t } from '../../shared/tokens';
import { IconEdit } from '../../shared/icons';

export default function CalmStatCard({
  label,
  value,
  tone = 'default',
  hint,
  meta,
  big = false,
  featured = false,
  editable = false,
  onEdit,
  children,
}) {
  const toneColor =
    tone === 'debit' ? t.debit : tone === 'credit' ? t.credit : t.text;

  return (
    <div
      style={{
        padding: big ? 'var(--stat-pad-big)' : 'var(--stat-pad)',
        background: featured
          ? `linear-gradient(145deg, ${t.surface2}, ${t.surface})`
          : t.surface,
        border: `1px solid ${featured ? t.borderS : t.border}`,
        borderRadius: 'var(--stat-radius)',
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        overflow: 'hidden',
        minHeight: big ? 'var(--stat-min-h-big)' : 'var(--stat-min-h)',
      }}
    >
      {featured && (
        <div
          className="calm-stat-halo"
          style={{
            position: 'absolute',
            top: -40,
            right: -40,
            width: 140,
            height: 140,
            borderRadius: '50%',
            background: `radial-gradient(circle, ${t.accentDim}, transparent 70%)`,
            pointerEvents: 'none',
          }}
          aria-hidden="true"
        />
      )}

      <div
        style={{
          fontSize: 'var(--stat-label)',
          color: t.textDim,
          fontWeight: 500,
          letterSpacing: 0.1,
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 8,
          fontFamily: t.fontUi,
        }}
      >
        <span>{label}</span>
        {editable && (
          <button
            type="button"
            onClick={onEdit}
            title="Modifier"
            aria-label="Modifier"
            className="calm-stat-edit"
            style={{
              width: 24,
              height: 24,
              flexShrink: 0,
              borderRadius: 7,
              background: 'rgba(255,255,255,0.04)',
              border: `1px solid ${t.border}`,
              color: t.textDim,
              cursor: 'pointer',
              display: 'grid',
              placeItems: 'center',
              padding: 0,
            }}
          >
            <IconEdit size={12} />
          </button>
        )}
      </div>

      {children ? (
        <div
          className="calm-stat-value"
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            paddingTop: 'var(--stat-value-pt)',
          }}
        >
          {children}
        </div>
      ) : (
        <div
          className="calm-stat-value"
          style={{
            fontFamily: t.fontMono,
            fontSize: big ? 'var(--stat-value-big)' : 'var(--stat-value)',
            fontWeight: 500,
            color: toneColor,
            letterSpacing: -0.8,
            fontVariantNumeric: 'tabular-nums',
            lineHeight: 1.1,
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            paddingTop: 'var(--stat-value-pt)',
          }}
        >
          {value}
        </div>
      )}

      {hint && (
        <div
          className="calm-stat-hint"
          style={{
            fontSize: 12,
            color: t.textMute,
            marginTop: 'auto',
            paddingTop: 14,
            fontFamily: t.fontUi,
          }}
        >
          {hint}
        </div>
      )}

      {meta && meta.length > 0 && (
        <div
          className="calm-stat-meta"
          style={{
            marginTop: 'auto',
            paddingTop: 14,
            display: 'flex',
            flexWrap: 'wrap',
            gap: '4px 14px',
            fontSize: 11,
            color: t.textMute,
            lineHeight: 1.35,
            fontFamily: t.fontUi,
          }}
        >
          {meta.map((m, i) => (
            <div key={i}>
              <span style={{ color: t.textDim, fontFamily: t.fontMono }}>
                {m.value}
              </span>{' '}
              {m.label}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
